import { ComponentEmotionWheelOnboarding, Maybe } from '@/graphql/generated/graphql';
import { useState } from 'react';
import Button from '../Button';
import Stepper from '../Stepper';
import { motion, AnimatePresence } from 'framer-motion';

export default function GenericOnboarding({
  onboarding,
  onFinish,
  showStepper = true,
}: {
  onboarding?: Maybe<ComponentEmotionWheelOnboarding>;
  onFinish: () => void;
  showStepper?: boolean;
}) {
  const [currentStep, setCurrentStep] = useState(0);

  if (!onboarding || !onboarding.steps || !onboarding.steps.length) return <></>;

  const step = onboarding?.steps[currentStep];

  const advanceOnboardingStep = () => {
    if (currentStep < (onboarding?.steps?.length || 0) - 1) {
      setCurrentStep(currentStep + 1);
      return;
    }

    onFinish();
  };

  const variants = {
    initial: { opacity: 0, x: 10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -10 },
  };

  return (
    <>
      <div className="col-span-12 flex flex-col items-center lg:col-start-3 lg:col-end-11">
        {showStepper && (
          <div className="mt-sh-15">
            <Stepper steps={onboarding?.steps?.length} step={currentStep} />
          </div>
        )}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5 }}
            className="mt-sh-30 flex flex-col items-center  gap-sh-30 xl:flex-row">
            <img
              src={step?.image?.data?.attributes?.url || ''}
              alt={step?.image?.data?.attributes?.alternativeText || ''}
              className="size-[300px] rounded-full"
            />
            <div className="flex flex-col items-start justify-center">
              <h2 className="mb-1 font-larken text-sh-28-32">{step?.title}</h2>
              <p className="mb-sh-15 text-sh-14-20">{step?.description}</p>
              <Button onClick={advanceOnboardingStep}>{step?.textBtn}</Button>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
}
